import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import AppShell from './AppShell';
import { Card, IconCircle } from './ui';

// Catches render-time errors so a component throw shows a recoverable
// message instead of white-screening the app. Keyed by route in App so
// navigating away clears the error. Ported from japan-trip.
interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[web] render error:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <AppShell>
          <Card>
            <div className="empty">
              <IconCircle icon="info" tone="owe" iconSize={22} />
              <h1 className="empty-title">Something went wrong</h1>
              <p className="empty-body">{this.state.error.message}</p>
              <a className="btn btn-secondary" href="/">
                Back to the ledger
              </a>
            </div>
          </Card>
        </AppShell>
      );
    }
    return this.props.children;
  }
}
